import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import Loader from "../../assets/icons/loader/loader";
import DeleteModal from "../../components/modal/delete-modal";
import AdminFilterDrawer from "../../components/filter/admin-filter-drawer";
import MainLayout from "../../layout";
import CustomerActivityViewModal from "../../components/customer-components/customer-activity/customer-activity-view-modal";
import { api } from "../../redux/apis/api";
import CustomerActivityEditModal from "../../components/customer-components/customer-activity/customer-activity-edit-modal";
import { useRole } from "../../context/role/RoleContext";
import Pagination from "../../components/pagination";

const CustomerActivityAllList = () => {
  const location = useLocation();
  const { state } = useRole();
  const permission = state?.role?.customer_activity;
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);

  const [data, setData] = useState({
    rows: [],
    page: 1,
    count: 0,
  });
  const [loading, setLoading] = useState(true);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [selectDelete, setSelectDelete] = useState("");
  const [leadsView, setLeadsView] = useState(false);
  const [selectID, setSelectID] = useState("");
  const [cusomerList, setCusomerListt] = useState([]);
  const [leadsEdit, setLeadsEdit] = useState(false);

  const fetchData = () => {
    const rawFilters = queryString.parse(location.search, {
      arrayFormat: "bracket",
    });

    const filters = normalizeParsedParams(rawFilters);

    setLoading(true);
    api
      .post(`/customer/activity/all/list`, {
        page: page_no,
        ...filters,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  function normalizeParsedParams(parsed) {
    const result = {};

    for (const [key, value] of Object.entries(parsed)) {
      const match = key.match(/^(\w+)\[(\w+)\]$/);
      if (match) {
        const [, parent, child] = match;
        if (!result[parent]) result[parent] = {};
        result[parent][child] = value;
      } else {
        result[key] = value;
      }
    }

    return result;
  }

  useEffect(() => {
    fetchData();
  }, [page_no, location.search]);

  const deleteFnc = (id) => {
    api
      .post(`/customer/activity/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
        fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  const fetchCustomerDropDownData = () => {
    api
      .get(`/customer/dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.customers?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCusomerListt(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    if (filterDrawerOpen) {
      fetchCustomerDropDownData();
    }
  }, [filterDrawerOpen]);

  const filterInputs = [
    {
      label: "customer",
      type: "dropdown",
      name: "customer_id",
      options: cusomerList,
    },
    {
      label: "title",
      type: "text",
      name: "title",
    },
    {
      label: "status",
      type: "dropdown",
      name: "status",
      options: [
        { label: "cancelled", value: "cancelled" },
        { label: "confirmed", value: "confirmed" },
        { label: "completed", value: "completed" },
      ],
    },
    {
      label: "type",
      type: "dropdown",
      name: "type",
      options: [
        { label: "call", value: "call" },
        { label: "sms", value: "sms" },
        { label: "quotation", value: "quotation" },
        { label: "visit", value: "visit" },
        { label: "meeting", value: "meeting" },
        { label: "complain resolution", value: "complain_resolution" },
        { label: "sales visit", value: "sales_visit" },
        { label: "sample request", value: "sample_request" },
        { label: "follow up", value: "follow_up" },
      ],
    },
    {
      label: "activity date",
      type: "date",
      name: "activity_date",
    },
    {
      label: "created At",
      type: "date",
      name: "createdAt",
    },
    {
      label: "updated At",
      type: "date",
      name: "updatedAt",
    },
  ];

  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const filters = searchParams.toString() ? `&${searchParams.toString()}` : "";

  const writePermission = (row) => {
    if (row?.assignedTo) {
      if (row?.assignedTo.write == true) {
        return true;
      }
      return false;
    }
    if (permission?.write == true) {
      return true;
    }
  };

  return (
    <MainLayout>
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
          setSelectDelete("");
        }}
        btnFnc={() => deleteFnc(selectDelete)}
      />
      <CustomerActivityViewModal
        selectID={selectID}
        isOpen={leadsView}
        onClose={() => {
          setLeadsView(false);
        }}
        deleteDisable={false}
      />
      <CustomerActivityEditModal
        selectID={selectID}
        isOpen={leadsEdit}
        onClose={() => {
          setLeadsEdit(false);
        }}
        listFnc={fetchData}
      />
      <section className="h-full">
        <div className="flex justify-between items-center mb-5">
          <h2 className="text-fs_14 md:text-fs_16 font-semibold capitalize">
            customer activity List
          </h2>
          <div className="flex gap-2 relative">
            <AdminFilterDrawer
              filterInputs={filterInputs}
              open={filterDrawerOpen}
              onClose={() => setFilterDrawerOpen(false)}
              queryParamsData={queryParamsData}
            />
            <button
              onClick={() => setFilterDrawerOpen(true)}
              className="md:px-4 md:py-2 px-2 py-1 text-fs_14 bg-secondary text-white rounded"
            >
              Filters
            </button>
          </div>
        </div>
        <div className="relative overflow-x-auto">
          <table className="w-full text-left rtl:text-right border border-gray-200">
            <thead className="text-gray-700 uppercase text-nowrap bg-white">
              <tr>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  id
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  customer
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  FF admin
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  title
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  description
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  status
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  type
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  activity date
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                >
                  activity time
                </th>
                <th
                  scope="col"
                  className="px-4 py-3 capitalize text-fs_16 font-fw_600 sticky right-0 z-10 bg-white"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td rowSpan={1}>
                    <div className="w-full flex justify-center py-5">
                      <div className="h-[100px] w-[100px]">
                        <Loader />
                      </div>
                    </div>
                  </td>
                </tr>
              ) : (
                <>
                  {data.rows?.length ? (
                    <>
                      {data.rows.map((row, index) => {
                        return (
                          <tr
                            key={index}
                            className="border-t bg-white text-nowrap"
                          >
                            <td className="p-1 px-2">{row?.id ?? "--"}</td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.customer?.name ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.ffAdminUsers?.name ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.title ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.description ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.status ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.type ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.activity_date ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.activity_time ?? "--"}
                              </span>
                            </td>
                            <td className="py-2 sticky right-0 z-10">
                              <div className="flex gap-3 bg-white px-4">
                                <button
                                  onClick={() => {
                                    setLeadsView(true);
                                    setSelectID(row["id"]);
                                  }}
                                  className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                >
                                  View
                                </button>
                                {writePermission(row) && (
                                  <button
                                    onClick={() => {
                                      setLeadsEdit(true);
                                      setSelectID(row["id"]);
                                    }}
                                    className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                  >
                                    Edit
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td>
                        <p className="text-center my-5">No data found</p>
                      </td>
                    </tr>
                  )}
                </>
              )}
            </tbody>
          </table>
        </div>
      </section>
      <div
        className={`${
          loading === true ? "pointer-events-none opacity-45" : ""
        }`}
      >
        <Pagination
          totalPages={parseInt(data?.count) ?? 0}
          pagination={parseInt(data?.page) ?? 0}
          path={`/customer-activity/list`}
          filters={filters}
        />
      </div>
    </MainLayout>
  );
};

export default CustomerActivityAllList;
